import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { apiPeriodGroupsSelector, filtersSelector } from '../../../redux/context/filters/selectors'
import { getDriverDataOptions } from './getDriverDataOptions'
import { DriverData } from '../types/driverData'

export const useDriverData = <TData = DriverData[]>(select?: (data: DriverData[]) => TData) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario, dimensionsQuery } = useSelector(filtersSelector)
  const periodGroups = useSelector(apiPeriodGroupsSelector)
  const options = getDriverDataOptions(companyId, budgetingScenario?.id, periodGroups, select, dimensionsQuery)
  return useQuery(options)
}
